import React, { useState, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const RichTextEditor = ({ initialValue, isEditable, onChange }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  useEffect(() => {
    if (initialValue) {
      const contentBlock = htmlToDraft(initialValue);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        setEditorState(EditorState.createWithContent(contentState));
      }
    }
  }, []); 

  const handleEditorChange = (state) => {
    setEditorState(state);
    const rawContentState = convertToRaw(state.getCurrentContent());
    const html = draftToHtml(rawContentState);
    onChange(html);
  };

  return (
    <div className="custom-editor-wrapper">
      <Editor
        editorState={editorState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName border rounded-3 p-3"
        editorClassName="editorClassName"
        onEditorStateChange={handleEditorChange}
        readOnly={!isEditable}
        toolbarHidden={!isEditable}
        editorStyle={{
          height: "200px", 
          overflow: "auto", 
         
        }}
      />
    </div>
  );
};

export default RichTextEditor;
